import useDegreeDetailV4 from "./rules/degreeDetailV4/useDegreeDetailV4";
import useExecEdATF from "./rules/execEdATF/useExecEdATF";
import useExecEdBTF from "./rules/execEdBTF/useExecEdBTF";
import useExecEdStickyCTA from "./rules/execEdStickyCTA/useExecEdStickyCTA";
import useExecEdLeadForm from "./rules/execEdLeadForm/useExecEdLeadForm";
import useExecEdDetailPageTest from "./rules/execEdDetailPageTest/useExecEdDetailPageTest";
import useHomepageOptimizationV3 from "./rules/homepageOptimizationV3/useHomepageOptimizationV3";
import useHomepagePromoBanner from "./rules/homepagePromoBanner/useHomepagePromoBanner";
import useOcPromoBanner from "./rules/ocPromoBanner/useOcPromoBanner";
import useInternalTrackSelect from "./rules/trackSelection/useInternalTrackSelect";
import useRegisterCTA from "./rules/registerCTA/useRegisterCTA";
import useTrackSelectionRedesign from "./rules/trackSelectionRedesign/useTrackSelectionRedesign";
import useCytMobileFirstRedesign from "./rules/cytMobileFirstRedesign/useCytMobileFirstRedesign";
import useHubCardReorder from "./rules/hubCardReorder/useHubCardReorder";
import useProductCardRedesign from "./rules/productCardRedesign/useProductCardRedesign";
import useLogistrationTest from "./rules/logistrationTest/useLogistrationTest";
import useDegreeDetailRedesignTrafficV5_2 from "./rules/degreeDetailRedesignTrafficV5_2/useDegreeDetailRedesignTrafficV5_2";
import useProgramRedesignTraffic from "./rules/programRedesignTraffic/useProgramRedesignTraffic";
import useHeroStatsRedesign from "./rules/heroStatsRedesign/useHeroStatsRedesign";
import useLearnPageRedesign from "./rules/learnPageRedesign/useLearnPageRedesign";
import useLearnerDashboardCTA from "./rules/learnerDashboardCTA/useLearnerDashboardCTA";
import useTuitionModule from "./rules/tuitionModule/useTuitionModule";
import useProductSearch from "./rules/productSearch/useProductSearch";
import useSearchPagePromo from "./rules/searchPagePromo/useSearchPagePromo";
import useSortedSearch from "./rules/sortedSearch/useSortedSearch";
import useLogistrationPageRedesign from "./rules/logistrationPageRedesign/useLogistrationPageRedesign";
import useHomepageLOBEntrypointsTest from "./rules/homepageLOBEntrypoints/useHomepageLOBEntrypointsTest";
import useSearchPageTemplate from "./rules/searchPageTemplate/useSearchPageTemplate";
import useExecPromoHighlight from "./rules/execEdPromoHighlight/useExecPromoHighlight";
import useStreamlineCheckout from "./rules/streamlineCheckout/useStreamlineCheckout";
import useSingleCourseTraffic from "./rules/singleCourseTraffic/useSingleCourseTraffic";
import useStatsAndSocialProofTest from "./rules/statsAndSocialProofTest/useStatsAndSocialProofTest";
import useAbandonedCart from "./rules/abandonedCart/useAbandonedCart";
import useAbandonedCartIntentMatch from "./rules/abandonedCartIntentMatch/useAbandonedCartIntentMatch";
import useMultiCart from "./rules/multiCart/useMultiCart";
import useUpskillingSurveyPromotion from "./rules/upskillingSurveyPromotion/useUpskillingSurveyPromotion";
import useDegreeLeadFormContext from "./rules/degreeLeadFormContext/useDegreeLeadFormContext";
import useFindYourPath from "./rules/findYourPath/useFindYourPath";
import useResourcePageSideRail from "./rules/resourcePageSideRail/useResourcePageSideRail";
import useDiscoverSearchSplit from "./rules/discoverSearchSplit/useDiscoverSearchSplit";
import useAuthxLogistrationSplit from "./rules/authxLogistrationSplit/useAuthxLogistrationSplit";
import useDynamicExperienceFlow from "./rules/dynamicExperienceFlow/useDynamicExperienceFlow";
import useGTMSpotlightCarousel from "./rules/gtmSpotlightCarousel/useGTMSpotlightCarousel";
import useGetStartedWithModule from "./rules/getStartedWith/useGetStartedWithModule";
import useUserSurvey from "./rules/userSurvey/useUserSurvey";
import useUmbrellaPromoPage from "./rules/umbrellaPromoPage/useUmbrellaPromoPage";
import useSchoolRedesign from "./rules/schoolRedesign/useSchoolRedesign";
import useGuidedPathVsDynamicFlow from "./rules/guidedPathVsDynamicFlow/useGuidedPathVsDynamicFlow";
import useAuthxRecommendationsRedesign from "./rules/authxRecommendationsRedesign/useAuthxRecommendationsRedesign";
import useSuperlativesModule from "./rules/superlativesModule/useSuperlativesModule";
import useHomepageTrendingCourseUpdate from "./rules/homepageTrendingCourseUpdate/useHomepageTrendingCourseUpdate";

// Define a common interface for experiment results
export interface MonarchTestResult<
  VariantType = string,
  DataType = Record<string, any>,
> {
  isLoading: boolean;
  variant?: VariantType;
  data?: DataType;
}

// Type for experiment hooks
export type MonarchTestHook<
  VariantType = string,
  DataType = Record<string, any>,
  PayloadType = unknown,
> = (payload?: PayloadType) => MonarchTestResult<VariantType, DataType>;

// Map of experiment rules
export const ruleMap: Record<string, MonarchTestHook<unknown, unknown, any>> = {
  useDegreeDetailV4,
  useHomepageOptimizationV3,
  useHomepagePromoBanner,
  useOcPromoBanner,
  useInternalTrackSelect,
  useExecEdATF,
  useExecEdBTF,
  useExecEdStickyCTA,
  useExecEdLeadForm,
  useExecEdDetailPageTest,
  useRegisterCTA,
  useTrackSelectionRedesign,
  useCytMobileFirstRedesign,
  useHubCardReorder,
  useProductCardRedesign,
  useLogistrationTest,
  useAuthxLogistrationSplit,
  useDegreeDetailRedesignTrafficV5_2,
  useProgramRedesignTraffic,
  useHeroStatsRedesign,
  useLearnPageRedesign,
  useLearnerDashboardCTA,
  useTuitionModule,
  useProductSearch,
  useSearchPagePromo,
  useSortedSearch,
  useLogistrationPageRedesign,
  useHomepageLOBEntrypointsTest,
  useSearchPageTemplate,
  useExecPromoHighlight,
  useStreamlineCheckout,
  useSingleCourseTraffic,
  useStatsAndSocialProofTest,
  useAbandonedCart,
  useAbandonedCartIntentMatch,
  useMultiCart,
  useUpskillingSurveyPromotion,
  useDegreeLeadFormContext,
  useFindYourPath,
  useResourcePageSideRail,
  useDiscoverSearchSplit,
  useDynamicExperienceFlow,
  useGTMSpotlightCarousel,
  useGetStartedWithModule,
  useUserSurvey,
  useUmbrellaPromoPage,
  useSchoolRedesign,
  useGuidedPathVsDynamicFlow,
  useAuthxRecommendationsRedesign,
  useSuperlativesModule,
  useHomepageTrendingCourseUpdate,
};

export function useMonarchTestResult<
  TestResult extends MonarchTestResult,
  PayloadType = unknown,
>(experimentKey: keyof typeof ruleMap, payload?: PayloadType): TestResult {
  const hook = ruleMap[experimentKey];

  if (!hook) {
    throw new Error(`MonarchTest "${experimentKey}" not found`);
  }

  const result = hook(payload) as TestResult;

  return {
    ...result,
    data: result.data || {},
  } as TestResult;
}
